<template>
  <div class="boss-layout boss-layout-start boss-layout-gap-large boss-layout-wrap">
    <div v-if="!noOption">
      <select
        :value="getSelectedOptionData.terms"
        class="boss-input-select"
        @change="onSelectedChange"
      >
        <option
          v-for="(option, i) in options"
          :key="i"
          :value="option.terms"
          :data-test="`select-option-${option.terms}`"
        >
          {{ option.name }}
        </option>
      </select>
    </div>
    <div>
      <date-picker
        :value="[from, to]"
        :disabled="isDisabled"
        :shortcuts="shortcuts"
        type="date"
        format="YYYY-MM-DD"
        :disabled-date="notAfterToday"
        :default-value="defaultDate"
        input-class="pega-picker"
        value-type="format"
        :editable="false"
        range
        placeholder="期間を選択"
        @input="onUpdateTerm"
      />
    </div>
    <span
      v-if="notice"
      class="boss-annotation-text"
      data-test="notice"
    >
      {{ notice }}
    </span>
  </div>
</template>

<script>
import { now } from '@/lib/dateUtils.js'
import _ from 'lodash'
import DatePicker from 'vue2-datepicker'

export default {
  components: {
    DatePicker
  },
  props: {
    dateLabel: {
      type: String,
      default: '期間'
    },
    selectedOption: {
      type: Object,
      default: () => { return { terms: 'select' } }
    },
    from: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    noOption: {
      type: Boolean,
      default: false
    },
    withoutToday: {
      type: Boolean,
      default: false
    },
    notice: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedOptionData: { terms: 'select' },
      optionsBase: [{
        terms: '',
        name: '指定なし'
      }, {
        terms: 'select',
        name: `${this.dateLabel}を指定`
      }, {
        terms: 0,
        name: `${this.dateLabel}が本日`
      }, {
        terms: 7,
        name: `${this.dateLabel}が1週間以内`
      }, {
        terms: 14,
        name: `${this.dateLabel}が2週間以内`
      }, {
        terms: 30,
        name: `${this.dateLabel}が30日以内`
      }, {
        terms: 90,
        name: `${this.dateLabel}が90日以内`
      }],
      shortcuts: [
        {
          text: '過去7日間',
          onClick: () => {
            return [now().subtract(7, 'days').toDate(), now().toDate()]
          }
        },
        {
          text: '過去30日間',
          onClick: () => {
            return [now().subtract(30, 'days').toDate(), now().toDate()]
          }
        }
      ],
      defaultDate: now().subtract(1, 'months').toDate()
    }
  },
  computed: {
    isDisabled () {
      return (this.selectedOptionData.terms !== 'select')
    },
    getSelectedOptionData () {
      return this.selectedOptionData
    },
    options () {
      if (this.withoutToday) { // 「本日（terms=0）」を除く
        return this.optionsBase.filter(option => { return option.terms !== 0 })
      } else {
        return this.optionsBase
      }
    }
  },
  watch: {
    'selectedOptionData.terms': {
      handler (val) {
        if (val !== undefined && val !== 'select') {
          const term = this.selectedTerm(val)
          this.onUpdateTerm(term)
        }
      },
      immediate: true
    }
  },
  created () {
    this.$set(this, 'selectedOptionData', this.selectedOption)
  },
  methods: {
    selectedTerm (val) {
      if (_.isInteger(val)) {
        return [
          now().subtract(val, 'days').format('YYYY-MM-DD'),
          now().format('YYYY-MM-DD')
        ]
      } else {
        return ['', '']
      }
    },
    onUpdateTerm (value) {
      this.$emit('update:from', value[0] === null ? '' : value[0])
      this.$emit('update:to', value[1] === null ? '' : value[1])
      this.selectedChange()
    },
    onSelectedChange (e) {
      if (e.target.value === '' || e.target.value === 'select') {
        this.selectedOptionData = _.find(this.options, { terms: e.target.value })
      } else {
        this.selectedOptionData = _.find(this.options, { terms: Number(e.target.value) })
      }
      if (this.selectedOptionData.terms === 'select' && this.from !== '' && this.to !== '') {
        this.selectedChange()
      }
    },
    selectedChange () {
      if (this.selectedOptionData.terms === '') {
        this.$set(this, 'selectedOptionData', {}) // 「指定なし」の場合は条件を保持
      }
      this.$emit('update:selectedOption', this.selectedOptionData)
    },
    notAfterToday (date) {
      return date > now()
    }
  }
}
</script>
